export class ImageFile {
  public static readonly DefaultUserImage = '/assets/img/default.jpg';
  public static readonly DefaultImage = '';
}
